import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';
import { mapStateToProps, mapDispatchToProps } from '../../utils';

class GlobalMessage extends Component {
  createMarkup() {
    return {
      __html: this.props.message,
    };
  }

  render() {
    return (
      <div className={css(styles.container)}>
        <div className={css(styles.global_message_box)}>
          <div className={css(styles.global_message_title_container, styles.larger)}>
            <div className={css(styles.global_message_title)}>
              { this.props.title }
            </div>
          </div>
          <div className={css(styles.global_message_container)}>
            <div
              className={css(styles.global_message)}
                // eslint-disable-next-line
                dangerouslySetInnerHTML={this.createMarkup()} />
          </div>
        </div>
      </div>
    );
  }
}

GlobalMessage.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
};

GlobalMessage.defaultProps = {
  title: '',
  message: '',
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    margin: 10,

    [Theme.mobile_query]: {
      width: 'auto',
    },
  },
  form_group: {
    display: 'flex',
    flexDirection: 'row',

    [Theme.mobile_query]: {
      flexDirection: 'column',
    },
  },
  global_message_box: {
    backgroundColor: Theme.white,
    position: 'relative',
    display: 'flex',
    padding: 20,
    flex: 1,
    height: 'auto',
    margin: '20px auto',
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',
    flexDirection: 'column',

    [Theme.mobile_query]: {
      flexDirection: 'column',
      height: 'auto',
    },
  },
  global_message_title_container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 15,

    [Theme.mobile_query]: {
      marginBottom: 15,
      flexDirection: 'column',
    },
  },
  larger: {
    flex: 2,
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  global_message_title: {
    fontFamily: Theme.font_family_heading,
    fontSize: 20,
    color: Theme.black,
    fontWeight: 'bold',
    marginRight: 10,

    [Theme.mobile_query]: {
      marginBottom: 5,
    },
  },
  global_message_container: {
    flex: 1,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',

    [Theme.mobile_query]: {
      marginBottom: 15,
      flexDirection: 'column',
    },
  },
  global_message: {
    fontFamily: Theme.font_family_heading,
    fontSize: 16,
    color: Theme.black,
    marginRight: 10,

    [Theme.mobile_query]: {
      marginBottom: 5,
    },
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalMessage);



// WEBPACK FOOTER //
// ./src/components/GlobalMessage/index.js